import productApi from "@/service/modules/productApi";
import { Button, Modal, Form, Input, InputNumber, message } from "antd";
import { useState } from "react";

interface Props {
  onClose: Function;
  isWholesaleOpen: boolean;
  productID?: number | undefined;
  productUrl?: string | undefined;
}

export default function Wholesale({ onClose, isWholesaleOpen, productID, productUrl }: Props) {
  const [btnLoading, setBtnLoading] = useState(false)

  const onFinish = async (values: any) => {
    setBtnLoading(true);
    let params = {
      ...values,
    };

    if (productUrl) params.productUrl = productUrl

    try {
      const res = await productApi.wholesale(params);
      const { send } = res.data;
      setBtnLoading(false);
      if (send) {
        message.success("Success");
        onClose();
      } else {
        message.error("Error");
      }
    } catch (error: any) {
      setBtnLoading(false);
      message.error(error.message);
    }
  };

  type FieldType = {
    contactEmail?: string;
    productID?: number;
    productInfo?: string;
    quantity?: number;
  };

  return (
    <Modal
      title=""
      centered
      open={isWholesaleOpen}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={null}
      width={689}
    >
      <div style={{ width: "575px", margin: "0 auto" }}>
        <p
          style={{
            color: "#333333",
            fontWeight: "bold",
            fontSize: "16px",
            margin: "27px 0",
          }}
        >
          For orders over 20 pcs or exceeding $2000 (QTY{">"}=5), we&apos;ll
          sort you a top-notch quote. Reach out for more details, cheers!
        </p>
        <Form name="wholesale" layout="vertical" onFinish={onFinish}>
          <Form.Item<FieldType>
            label="Your contact email:"
            name="contactEmail"
            rules={[
              { required: true, message: "Please input your contact email!" },
              { type: "email" },
            ]}
          >
            <Input placeholder="Your Email Address" />
          </Form.Item>

          {productID && (
            <Form.Item<FieldType>
              label="Items you want to bulk buy:"
              name="productID"
              rules={[
                { required: true, message: "Please input your PID number!" },
              ]}
              initialValue={productID}
            >
              <Input
                placeholder="Enter the item's link or PID number (the PID No. is above the product title)"
                disabled
              />
            </Form.Item>
          )}

          {!productID && (
            <Form.Item<FieldType>
              label="Items you want to bulk buy:"
              name="productInfo"
              rules={[
                {
                  required: true,
                  message:
                    "Please input the item's link or PID number (the PID No. is above the product title)",
                },
              ]}
            >
              <Input placeholder="Enter the item's link or PID number (the PID No. is above the product title)" />
            </Form.Item>
          )}

          <Form.Item<FieldType>
            label="How many items do you want?"
            name="quantity"
            rules={[{ required: true, message: "Please input your number!" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={1}
              placeholder="Example:100"
            />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              type="primary"
              loading={btnLoading}
              htmlType="submit"
              style={{ width: "136px", height: "32px", padding: "0" }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}
